<template>
  <a-layout-sider
    width="256px"
    :class="[theme, 'sider', isMobile ? null : 'shadow']"
    :collapsible="collapsible"
    v-model="collapsed"
    :trigger="null"
  >
    <div :class="['logo', theme]">
      <router-link to="/home">
        <img v-if="logo" :src="logo">
        <img v-else src="../../assets/images/logo.png" />
        <h1>{{ systemName }}</h1>
      </router-link>
    </div>
    <!-- <i-menu :theme="theme" :collapsed="collapsed" :menuData="leftMenuData" @select="onSelect"/> -->
    <a-menu
      mode="inline"
      :selectedKeys="[selectedKeys]"
      :theme="theme"
      :inlineCollapsed="collapsed"
      :openKeys="openKeys"
      @openChange="onOpenChange"
    >
      <template v-for="item in leftMenuData">
        <a-sub-menu v-if="item.hasChild" :key="item.path">
          <span slot="title">
            <a-icon :type="item.icon" />
            <span>{{ item.name }}</span>
          </span>
          <!-- 第二层 -->
          <template v-for="item2 in item.children">
            <a-sub-menu v-if="item2.hasChild" :key="item2.path">
              <span slot="title">
                <a-icon :type="item2.icon" />
                <span>{{ item2.name }}</span>
              </span>
              <!-- 第三层 -->
              <template v-for="item3 in item2.children">
                <a-sub-menu v-if="item3.hasChild" :key="item3.path">
                  <span slot="title">
                    <a-icon :type="item3.icon" />
                    <span>{{ item3.name }}</span>
                  </span>
                  <!-- 第三层 -->
                  <!-- <template v-for="(item4, index) in item3.children">
                  </template>-->
                  <a-menu-item
                    v-for="item4 in item3.children"
                    @click="handleSelectMenu(item4)"
                    :key="item4.path"
                  >
                    <a-icon :type="item4.icon" />
                    <span>{{ item4.name }}</span>
                  </a-menu-item>
                </a-sub-menu>
                <!-- 第一层 -->
                <a-menu-item
                  v-else
                  @click="handleSelectMenu(item3)"
                  :key="item3.path"
                >
                  <a-icon :type="item3.icon" />
                  <span>{{ item3.name }}</span>
                </a-menu-item>
              </template>
            </a-sub-menu>
            <a-menu-item
              v-else
              @click="handleSelectMenu(item2)"
              :key="item2.path"
            >
              <a-icon :type="item2.icon" />
              <span>{{ item2.name }}</span>
            </a-menu-item>
          </template>
        </a-sub-menu>
        <!-- 第一层 -->
        <a-menu-item v-else @click="handleSelectMenu(item)" :key="item.path">
          <a-icon :type="item.icon" />
          <span>{{ item.name }}</span>
        </a-menu-item>
      </template>
    </a-menu>
    <slot></slot>
  </a-layout-sider>
</template>

<script>
import config from '../../../config';
export default {
  name: 'SiderMenu',
  props: {
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    menuData: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    }
  },
  computed: {
    leftMenuData() {
      let copyMenuData = Array.from(this.menuData);
      let leftMenuData = [];
      leftMenuData = copyMenuData.filter(item => {
        if (!item.invisible) {
          this.loopChild(item);
          return item;
        }
      });
      return leftMenuData;
    },
    isMobile() {
      return this.$store.state.setting.isMobile;
    },
    systemName() {
      return this.$store.state.setting.systemName;
    }
  },
  data() {
    return {
      logo: config.web && config.web.logo,
      loopChildTimes: 0,
      selectedKeys: '/home',
      openKeys: []
    };
  },
  watch: {
    $route: function(newRoute, oldRoute) {
      this.selectKey(newRoute);
    }
  },
  created() {
    this.selectKey(this.$route);
  },
  methods: {
    onOpenChange(openKeys) {
      console.log('openKeys', openKeys);
      const latestOpenKey = openKeys.find(
        key => this.openKeys.indexOf(key) === -1
      );
      if (this.leftMenuData.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },

    selectKey($route) {
      this.selectedKeys = $route.meta.selectedKeys
        ? $route.meta.selectedKeys
        : $route.path;
    },

    onSelect(obj) {
      this.$emit('menuSelect', obj);
    },

    handleSelectMenu(item) {
      this.$router.push({
        path: item.path
      });
    },

    loopChild(data) {
      let children = data.children;
      if (children && children.length) {
        let children = [];

        this.loopChildTimes++;
        if (this.loopChildTimes >= 20) {
          console.warn('递归处理children超过20次');
          return;
        } else {
          data.children.forEach(child => {
            if (!child.invisible) {
              children.push(child);
            }
            this.loopChild(child);
          });
        }

        data.children = children;

        if (data.children.length) {
          data.hasChild = true;
        }
      } else {
        data.hasChild = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.shadow
  box-shadow 2px 0 6px rgba(0, 21, 41, 0.35)
.sider
  z-index 10
  &.light
    background-color #fff
  &.dark
    background-color #001529
  .logo
    height 64px
    position relative
    line-height 64px
    padding-left 24px
    -webkit-transition all 0.3s
    transition all 0.3s
    overflow hidden
    &.light
      background-color #fff
      h1
        color #1890ff
    &.dark
      background-color #002140
      h1
        color #fff
    h1
      color #fff
      font-size 18px
      margin 0 0 0 12px
      font-family 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif
      font-weight 600
      display inline-block
      height 32px
      line-height 32px
      vertical-align middle
    img
      width 32px
      display inline-block
      vertical-align middle
</style>
